export default "__VITE_ASSET__B36tr_K9__"